import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

//styles
import './App.css'

//Pages and component
import Dashboard from '././Pages/dashboard/Dashboard'
import Create from './Pages/create/Create'
import Login from './Pages/login/Login'
import Signup from './Pages/signup/Signup'
import Project from './Pages/project/Project'
import { Navbar } from './components/Navbar'
import { Sidebar } from './components/Sidebar'
import { useAuthcontext } from './hooks/useAuthcontext'
import { OnlineUsers } from './components/OnlineUsers'

function App() {
  const{user, authIsReady} = useAuthcontext()
  return (
    <div className="App">
      {authIsReady && (
      <BrowserRouter>
        <Sidebar/>
        <div className='container'>
          <Navbar/>
          <Routes>
            <Route path='/'element={user ? <Dashboard/> : <Navigate to="/login"/>}/>
            <Route path='/create'element={user ? <Create/> : <Navigate to="/login"/>}/>
            <Route path='/projects/:id'element={user ? <Project/> : <Navigate to="/login"/>}/>
            <Route path='/signup'element={!user ? <Signup/> : <Navigate to="/"/>}/>
            <Route path='/login'element={!user ? <Login/> : <Navigate to="/"/>}/>
          </Routes>
        </div>
        {user && <OnlineUsers/>}
      </BrowserRouter>
      )}
    </div>
  );
}

export default App
